import { Box, Grid } from '@mui/material';
import React from 'react';

import AmountSummary from './components/AmountSummary';
import DetailsSummary from './components/DetailsSummary';

interface ConfirmingPayment {
  amount: number;
  businessDestinationIdentifier?: string;
  businessDestinationName?: string;
  executedAt?: Date | string;
}

interface ConfirmingRequest {
  payments?: ConfirmingPayment[];
  stakeholderName?: string;
  stakeholderIdentifier?: string;
  createdAt?: Date | string;
}

interface Props {
  request: ConfirmingRequest;
  onExport?: () => void | Promise<void>;
}

const PayOutSummaryConfirming: React.FC<Props> = ({ request, onExport }) => {
  return (
    <Box sx={{ py: 1.5 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <DetailsSummary request={request} />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: '1px',
              backgroundColor: 'divider',
              display: { xs: 'none', md: 'block' },
            },
          }}
        >
          <AmountSummary request={request} onExport={onExport} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PayOutSummaryConfirming;
